// ./appleAuth.jsx
import React, { useEffect } from "react";

const AppleAuth = ({ appleLoginFunction, clientId, redirectURI }) => {
  useEffect(() => {
    if (!clientId || !redirectURI) {
      console.error("[AppleAuth] Missing clientId or redirectURI");
      return;
    }

    const ensureScript = () =>
      new Promise((resolve, reject) => {
        if (window.AppleID?.auth) return resolve();
        const s = document.createElement("script");
        s.src =
          "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
        s.onload = () => resolve();
        s.onerror = reject;
        document.body.appendChild(s);
      });

    let mounted = true;

    (async () => {
      try {
        await ensureScript();
        if (!mounted) return;

        // IMPORTANT: ask for id_token as well as code
        window.AppleID.auth.init({
          clientId, // e.g. "gr.paliaflorina.web"
          scope: "name email",
          redirectURI, // e.g. "https://paliaflorina.gr/auth/apple/callback"
          usePopup: true,
          response_type: "code id_token",
          response_mode: "fragment",
        });

        // Custom launcher for your button
        window.appleStartSignIn = async () => {
          try {
            const res = await window.AppleID.auth.signIn();
            appleLoginFunction?.(res);
          } catch (err) {
            console.error("Apple sign-in failed", err);
          }
        };
      } catch (e) {
        console.error("Failed to init Apple JS", e);
      }
    })();

    return () => {
      mounted = false;
      if (window.appleStartSignIn) delete window.appleStartSignIn;
    };
  }, [appleLoginFunction, clientId, redirectURI]);

  return null; // no UI
};

export default AppleAuth;
